import {
  GET_LOCATIONS_REQUEST,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
} from "./actionTypes";

const initialState = {
  locations: [],
  isLoading: false,
  error: null,
};

const Location = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locations: action.payload,
      };
    case GET_LOCATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Location;
